export default __webpack_public_path__ + "static/media/thumb_8.0fa01894.webp";